

const routesSettings = require('@/../routes.json');

export const getDefaultRouteName = (route) => {
  return route.name && route.name.split("__")[0];
}

export const getLangFromRoute = (route) => {
  return route.name && route.name.split("__")[1];
}

export const getPageTitle = (route) => {
  return routesSettings.meta[getLangFromRoute(route)]['titles'][getDefaultRouteName(route)];
}

export const getPageMetaDescription = (route) => {
  return routesSettings.meta[getLangFromRoute(route)]['description'][getDefaultRouteName(route)];
}

export const setPageTitle = (title) => {
  if (document) {
    document.title = title;
  }
};

export const setMeta = (key, value) => {
  if (document) {
    const el = document.head.querySelector(`meta[name=${key}]`);
    if (el) {
      el.content = value;
    }
  }
}